module.exports = {"131103100":"冀州镇","131103102":"官道李镇","131103103":"南午村镇","131103104":"周村镇","131103105":"码头李镇","131103106":"西王镇","131103200":"门家庄乡","131103201":"徐家庄乡","131103202":"北漳淮乡","131103203":"小寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131103.json
// module id = 244
// module chunks = 0